import { library } from '@fortawesome/fontawesome-svg-core';

// Selective imports for Pro Light icons (fal)
import {
  faInfoCircle,
  faPlusCircle,
  faTrash,
  faEdit,
  faAngleLeft,
  faTimes,
  faCheck,
  faClock,
  faSync,
  faArrowLeft,
  faBars,
  faStar,
  faFilter,
  faCalendarPlus,
  faTimesCircle,
  faCheckCircle,
  faUser,
  faUsers,
  faUserPlus,
  faCirclePlus,
  faStickyNote,
  faImage,
  faList,
  faHome,
  faUserGroup,
  faNoteSticky,
  faEnvelope,
  faChartLine,
} from '@fortawesome/pro-light-svg-icons';

// Selective imports for Free Solid icons (fas)
import {
  faFileImage,
  faImages,
  faPlus,
  faGripVertical,
  faUpload,
  faFloppyDisk,
  faRepeat,
  faGear,
  faArrowRightFromBracket,
  faUserGroup as fasUserGroup,
  faNoteSticky as fasNoteSticky,
  faEnvelope as fasEnvelope,
  faChartLine as fasChartLine,
  faSignOutAlt,
  faCog,
  faUsers as fasUsers,
  faUser as fasUser,
  faClock as fasClock,
  faUserPlus as fasUserPlus,
  faCirclePlus as fasCirclePlus,
  faStickyNote as fasStickyNote,
  faImage as fasImage,
  faList as fasList,
  faHome as fasHome,
} from '@fortawesome/free-solid-svg-icons';

import FontAwesomeIcon from './FontAwesomeIcon.vue';

// Add only the icons we actually use
library.add(
  // Pro Light icons
  faInfoCircle,
  faPlusCircle,
  faTrash,
  faEdit,
  faAngleLeft,
  faTimes,
  faCheck,
  faClock,
  faSync,
  faArrowLeft,
  faBars,
  faStar,
  faFilter,
  faCalendarPlus,
  faTimesCircle,
  faCheckCircle,
  faUser,
  faUsers,
  faUserPlus,
  faCirclePlus,
  faStickyNote,
  faImage,
  faList,
  faHome,
  faUserGroup,
  faNoteSticky,
  faEnvelope,
  faChartLine,
  
  // Free Solid icons
  faFileImage,
  faImages,
  faPlus,
  faGripVertical,
  faUpload,
  faFloppyDisk,
  faRepeat,
  faGear,
  faArrowRightFromBracket,
  fasUserGroup,
  fasNoteSticky,
  fasEnvelope,
  fasChartLine,
  faSignOutAlt,
  faCog,
  fasUsers,
  fasUser,
  fasClock,
  fasUserPlus,
  fasCirclePlus,
  fasStickyNote,
  fasImage,
  fasList,
  fasHome,
);

export default FontAwesomeIcon;
